import { Injectable } from '@angular/core';

import { Observable, of } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class CacheService {
  private readonly StoreToken = 'EIQ_CACHE_STORE';

  set(cacheKey: string, data: any): void {
    let cacheStore: string | { [key: string]: unknown } = sessionStorage.getItem(this.StoreToken);
    if (!cacheStore) {
      cacheStore = {};
    } else {
      cacheStore = JSON.parse(cacheStore);
    }

    cacheStore[cacheKey] = JSON.stringify(data);
    sessionStorage.setItem(this.StoreToken, JSON.stringify(cacheStore));
  }

  get(cacheKey: string): Observable<any> {
    let cacheStore = sessionStorage.getItem(this.StoreToken);
    if (!cacheStore) {
      return of(null);
    }

    cacheStore = JSON.parse(cacheStore);
    const cachedItem = cacheStore[cacheKey];
    return of(cachedItem ? JSON.parse(cachedItem) : null);
  }

  clearByKey(cacheKey: string): void {
    const cacheStore: string = sessionStorage.getItem(this.StoreToken);
    const { [cacheKey]: _removedKey, ...updatedCache } = JSON.parse(cacheStore);
    sessionStorage.setItem(this.StoreToken, JSON.stringify(updatedCache));
  }

  clear(): void {
    sessionStorage.setItem(this.StoreToken, JSON.stringify({}));
  }
}
